// extracted by mini-css-extract-plugin
export var equalColumn = "_en-0";